<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">Confirm and Proceed</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row" v-if="testCreated && selectedTest">
      <sui-button primary content="How to conduct the sociogram" icon="question circle" v-on:click="openGallery(1)" />
    </div>
    <div class="row">
      <div v-if="testCreated && selectedTest" class="ui ordered steps">
        <div class="completed step">
          <div class="content">
            <div class="title">Class selection</div>
            <div class="description">
              Selected class: {{ selectedClass.name }}
            </div>
          </div>
        </div>
        <div class="completed step">
          <div class="content">
            <div class="title">Student selection</div>
            <div class="description">
              {{ classStudents.length }} students in class
            </div>
          </div>
        </div>
        <div class="completed step">
          <div class="content">
            <div class="title">Confirm</div>
            <div class="description">Ready for Student Nominations!</div>
          </div>
        </div>
      </div>
      <div v-else class="ui ordered steps">
        <div class="completed step">
          <div class="content">
            <div class="title">Class selection</div>
            <div class="description">
              <router-link to="/class/select">Selected class: {{ selectedClass.name }}</router-link>
            </div>
          </div>
        </div>
        <div class="completed step">
          <div class="content">
            <div class="title">Student selection</div>
            <div class="description">
              <router-link to="/student/select">
                {{ classStudents.length }} students in class
              </router-link>
            </div>
          </div>
        </div>
        <div class="active step">
          <div class="content">
            <div class="title">Confirm</div>
            <div class="description">Verify and Proceed</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <div v-if="testCreated && selectedTest">
        <h3>The Nominations page is now available to students.</h3>
        <p>Students must open the URL below on their browser to begin:</p>
        <h3>
          <a :href="studentAppUrl" target="_blank">{{ studentAppUrl }}</a>
        </h3>
        <div style="margin: 20px 0;">
          <qrcode :value="studentAppUrl" :options="{ width: 200 }"></qrcode>
          <p style="margin-top: 10px;">Or share and scan this QR code to open the nominations page
          </p>
        </div>
        <router-link to="/">
          <sui-button content="Go back home" positive icon="thumbs up" />
        </router-link>
      </div>
      <div v-else>
        <div>
          <start-test-form v-bind:test="test" v-on:saved="testStarted" v-bind:error="startTestError"
            ref="startTestForm" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StartTestForm from '@/components/tests/StartTestForm';
import VueQrcode from '@chenfengyuan/vue-qrcode';

const studentAppBaseUrl = process.env.STUDENT_APP_URL;

export default {
  name: 'StartTest',
  components: { StartTestForm, qrcode: VueQrcode },
  computed: {
    ...mapGetters({
      classStudents: 'classStudents',
      selectedClass: 'selectedClass',
      selectedTest: 'selectedTest',
      school: 'usersSchool',
    }),
  },
  data() {
    return {
      startTestError: null,
      testCreated: false,
      studentAppUrl: null,
      test: {
        ValidForHours: 1,
        ClassId: null,
        DefaultLanguage: 'en',
      },
    };
  },
  methods: {
    openGallery(index) {
      this.$store.dispatch('showImage', { index });
    },
    testStarted() {
      this.startTestError = null;
      this.test.ClassId = this.selectedClass.id;
      this.$store.dispatch('startTest', this.test).then(
        () => {
          this.testCreated = true;
          this.studentAppUrl = `${studentAppBaseUrl}/${this.selectedTest.test.code}`;
        },
        (error) => {
          this.startTestError = error.response.data;
        },
      );
    },
  },
  async created() {
    await this.$store.dispatch('getSchoolForUser');
    if (this.school == null) {
      this.test.DefaultLanguage = 'en';
    } else {
      // eslint-disable-next-line no-lonely-if
      if (this.school.length === 0) {
        this.test.DefaultLanguage = 'en';
      } else {
        this.test.DefaultLanguage = this.school.defaultLanguage;
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/StartTest.vue